import store from 'nette-base-module/js/store'
import DefaultView from 'nette-back-module/js/views/back.default'
import merge from 'lodash/merge'
import NetteAjax from 'nette-base-module/js/nette/NetteAjax'

export default merge({
  created () {
    // console.log('here!!')
  },
  data () {
    return {
      percentCompleted: 0,
      uploadError: false
    }
  },
  computed: {
    uploaderOptions () {
      return {
        url: this.$presenter.uploadUrl,
        exts: null,
        maxUploadFiles: 50,
        onFileUploadDone: this.fileUploadDone,
        onProgress: this.progress,
        onError: this.error,
        name: 'qqfile'
      }
    },
    mediaObjectsComputed: {
      get () {
        return [...this.$presenter.mediaObjects]
      },
      set (val) {
        store.dispatch('nette/updateDataKey', {
          data: val,
          key: 'mediaObjects'
        })
      }
    }
  },
  methods: {
    selectObject (image) {
      this.$store.dispatch('mediaGallery/setSelected', image)
      if (this.$store.state.mediaGallery.isMultiple === false && this._snippetName === 'modalmedia') {
        NetteAjax.ext('vue-modal').$vfm.hide('modalmedia')
      }
    },
    hideModal () {
      NetteAjax.ext('vue-modal').$vfm.hide('modalmedia')
    },
    fileUploadDone(data) {
      if (data.error) {
        this.error(data.error)
        return
      }
      this.mediaObjectsComputed = [data].concat(this.mediaObjectsComputed)
      this.uploadError = false
    },
    error (error) {
      this.uploadError = error
    },
    progress (progress, percentCompleted) {
      this.percentCompleted = percentCompleted
      this.uploadError = false

      if (percentCompleted === 100) {
        setTimeout(() => {
          this.percentCompleted = 0
        }, 1000)
      }
    }
  }
}, DefaultView)
